import * as React from "react";

import "./assign-names-section.scss";

import {cs} from "@Common/react/chain-services";

import {ErrorHighlighter} from "../../../../../../../light/error-highlighter";
import {NamingPanel}      from "../../naming-panel/naming-panel";

export const AssignNamesSection = ({data, next, xdQaName=undefined}) => cs(
    ["errorHighlighter", (_, next) => ErrorHighlighter({next})],
    ({errorHighlighter}) => next({
        invalid: (data.value.type === "custom" && !data.value.value),
        highlightErrors: () => {
            errorHighlighter.start();
        },
        render: ({showErrors}) => (
            <div className="assign-names-section-22i">
                <div className="title" xd-qa-type="label" xd-qa-name={xdQaName+" Assign Names"}>
                    Assign Names
                </div>

                {NamingPanel({
                    data, showErrors,
                    customNameCss: errorHighlighter.css,
                    xdQaName,
                })}
            </div>
        ),
    }),
);


